<template>
  <div>
    <!-- No gate screen: the URL carries a SHA-256 hash of the website's
         document ID (not the ID itself), resolved back to the real
         configuration before mounting the widget. -->
    <chatbot-widget
      v-if="chatbotConfig"
      :configuration="chatbotConfig"
      @redirection="evt => handleRedirection(evt)"
    />

    <p v-else-if="notFound" class="direct-site__error">
      Chatbot configuration not found.
    </p>
  </div>
</template>

<script>
  import { resolveWebsiteIdByHash } from '../firebase';

export default {
  name: 'DirectSite',
  props: {
    hash: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chatbotConfig: null,
      notFound: false,
    };
  },
  async created() {
    try {
      const websiteId = await resolveWebsiteIdByHash(this.hash);
      if (websiteId) {
        this.chatbotConfig = websiteId;
      } else {
        this.notFound = true;
      }
    } catch (error) {
      console.error('Failed to resolve chatbot configuration:', error);
      this.notFound = true;
    }
  },
  methods: {
    handleRedirection(evt) {
      console.log('Redirection event:', evt.detail[0].url);
      console.log('Redirection event utm_source:', evt.detail[0].utm_source);
      window.location.href = evt.detail[0].url;
    },
  },
};
</script>

<style>
.direct-site__error {
  margin: 20px;
  color: #c62828;
  font-size: 14px;
}
</style>
